export type LegalAudience = "talent" | "company";

export interface LegalLinks {
  termsUrl: string;
  privacyUrl: string;
}

const LEGAL_LINKS: Record<string, Record<LegalAudience, LegalLinks>> = {
  momhunting: {
    talent: {
      termsUrl: "https://momhunting.com/agb-talent/",
      privacyUrl: "https://momhunting.com/datenschutz/",
    },
    company: {
      termsUrl: "https://momhunting.com/agb-unternehmen/",
      privacyUrl: "https://momhunting.com/datenschutz/",
    },
  },
  flextalent: {
    talent: {
      termsUrl: "https://oceansmillion.io/agb-talent/",
      privacyUrl: "https://oceansmillion.io/datenschutz/",
    },
    company: {
      termsUrl: "https://oceansmillion.io/agb-unternehmen/",
      privacyUrl: "https://oceansmillion.io/datenschutz/",
    },
  },
};

export function getLegalLinks(brand: string, audience: LegalAudience = "talent"): LegalLinks {
  const brandLinks = LEGAL_LINKS[brand] ?? LEGAL_LINKS["momhunting"];
  return brandLinks[audience];
}
